import React, { useState, useEffect } from "react";
import { Configurations } from "../../../Utils/Configurations";
import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from "react-router-dom";
import Pagination from "rc-pagination";
import qs from 'qs';
import ImagemFukyo from "../../../Components/Imagem-Fukyo/Imagem-Fukyo";
import moment from "moment/moment";
import ErrorModal from "../../../Components/ErrorModal/ErrorModal";

const CileContentBooks = (props) => {

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [paginacao, setPaginacao] = useState({})
    const [textBusca, setTextBusca] = useState("")
    const values = qs.parse(window.location.search)
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        chamadaLivros()
    }, [])

    useEffect(() => {
        chamadaLivros()
    }, [window.location.search])

    const chamadaLivros = () => {
        const config = new Configurations();
        const pagina = parseInt(values["?pagina"], 10);
        setLoading(true);
        let buscaParam = textBusca || values.busca || '';
        let url = config.apiBasePath + `/conteudo-cile/livros/lista?limite=10&pagina=${pagina}`;
        if (buscaParam) {
            url += `&busca=${encodeURIComponent(buscaParam)}`;
        }
        axios.get(url)
            .then(response => {
                setData(response.data)
                setPaginacao({
                    ...response.data.paginacao,
                })
            })
            .catch(error => {
                setErrorMessage(error.response.data.message || "Ocorreu um erro ao buscar os livros.");
                toggleErrorModal();
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const onChangePage = (page) => {
        setPaginacao({
            ...paginacao,
            paginaAtual: page
        })
        let url = `livros?pagina=${page}&limite=10`;
        if (textBusca) {
            url += `&busca=${encodeURIComponent(textBusca)}`;
        }
        props.history.push(url);
    }

    const editLivro = (id) => {
        props.history.push({
            pathname: `livros/detalhes/${id}`,
        });
    };

    const disableLivro = (item) => {
        const config = new Configurations();
        axios.post(config.apiBasePath + `/conteudo-cile/livros/status/${item.id}/desativar`)
            .then(() => {
                chamadaLivros()
            })
            .catch(error => {
                console.log("ERROR: ", error)
            });
    }

    const enableLivro = (item) => {
        const config = new Configurations();
        axios.post(config.apiBasePath + `/conteudo-cile/livros/status/${item.id}/publicar`)
            .then(() => {
                chamadaLivros()
            })
            .catch(error => {
                console.log("ERROR: ", error)
            });
    }

    const changeCardColor = (status) => {
        let textColor = 'text-white'
        switch (status) {
            case 'Disponível':
                return { bg: 'success', text: 'success', textColor: textColor, btn: 'light' };
            case 'Agendado':
                return { bg: 'info', text: 'info', textColor: textColor, btn: 'light' };
            case 'Indisponível':
                return { bg: 'secondary', text: 'secondary', textColor: textColor, btn: 'light' };
            case 'Não agendado':
                return { bg: 'warning', text: 'cinzaRD', textColor: 'cinzaRD', btn: 'cinzaRD' };

            default:
                return { bg: 'info', text: 'info', textColor: textColor, btn: 'light' };
        }
    }

    const onBuscar = () => {
        let url = `livros?pagina=1&limite=10`;
        if (textBusca) {
            url += `&busca=${encodeURIComponent(textBusca)}`;
        }
        props.history.push(url);
    };

    const toggleErrorModal = () => {
        setOpenErrorModal(!openErrorModal);
    }

    const clearBusca = () => {
        setTextBusca('');
        props.history.push('livros?pagina=1&limite=10');
    }

    return (
        <>
            <div className="cile-remessas">
                <div className="row">
                    <div className="col-12 py-2">
                        <div className="row no-gutters align-items-center">
                            <div className="col-12 col-lg-4 text-center text-lg-left">
                                <h2 className="title-1 d-none d-lg-block">CILE - Livros </h2>
                            </div>
                            <div className="col-6 col-lg-4 text-center d-flex align-items-center justify-content-center">
                                <form onSubmit={(e) => { e.preventDefault(); onBuscar(); }} className="form-inline">
                                    <input name="busca" type="text" className="form-control" placeholder="Digite o título do livro" autoComplete="off" value={textBusca} onChange={(e) => setTextBusca(e.target.value)} required={false} />
                                    <button className="btn btn-sm btn-outline-success ml-2" disabled={!textBusca} type="submit">Buscar</button>
                                </form>
                                {values.busca &&
                                    <button className="btn btn-link ml-2" onClick={() => clearBusca()}>x Limpar</button>
                                }
                            </div>
                            <div className="col-6 col-lg-4 text-center text-lg-right">
                                <div className="row no-gutters">
                                    <div className="col py-2 py-lg-0">
                                        <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="row no-gutters d-flex justify-content-center align-items-center py-lg-4">

                        {loading ?
                            <div className="d-flex justify-content-center w-100">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                            :
                            <>
                                <div className="lista-conteudo">
                                    {values.busca && (
                                        <div className="col-12 text-center">
                                            <h5>Resultados para: <strong>{values.busca}</strong></h5>
                                        </div>
                                    )}
                                    {(data.livros).map((item, indice) => {
                                        return (
                                            <div className="col-lg-10 col-12 pt-2 mt-3 offset-lg-1 offset-0 content-product " key={indice} >
                                                <div className="card bg-white">
                                                    <div className={`bg-${changeCardColor(item.statusPublicacao).bg} ${changeCardColor(item.statusPublicacao).textColor} card-header`}>
                                                        <div className="row no-gutters">
                                                            <div className="col-12 pb-3 pb-lg-0">
                                                                <div className="row no-gutters">
                                                                    <div className="col-4 border-white">
                                                                        <span className="tipo-label d-flex align-items-center">
                                                                            Livros
                                                                        </span>

                                                                    </div>
                                                                    <div className="col-4 col-md-4 text-center border-white d-flex justify-content-center align-items-center">
                                                                        {data &&
                                                                            <button className={`btn btn-outline-${changeCardColor(item.statusPublicacao).btn}`} type="button" onClick={() => editLivro(item.id)} >
                                                                                Editar Livro
                                                                            </button>
                                                                        }
                                                                    </div>

                                                                    <div className="col-4 col-md-4 text-right d-flex justify-content-end align-items-center">
                                                                        {item.visible ?
                                                                            <i className={`far fa-eye-slash icones-destaques-ativos cursor-pointer`} onClick={() => disableLivro(item)}></i>
                                                                            :
                                                                            <i className={`far fa-eye icones-destaques-ativos cursor-pointer`} onClick={() => enableLivro(item)}></i>
                                                                        }

                                                                        <h5 className="m-0"><span className={`text-${changeCardColor(item.statusPublicacao).text} mx-3 badge bg-white`}>{item.statusPublicacao}</span></h5>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className={`card-body pt-3`}>
                                                        <div className="card-body pt-3">
                                                            <div className="row no-gutters">
                                                                <div className="col-2 d-lg-block d-none">
                                                                    <ImagemFukyo
                                                                        className={`img img-fluid`}
                                                                        src={`https://api.ciledigital.com.br/file/images/${item.image}`}
                                                                        alt={`imagem-destaque`}
                                                                    />

                                                                </div>
                                                                <div className="col-lg-10 col-12  px-lg-4 px-0" >
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            {data && !!item &&
                                                                                <>
                                                                                    <p className="infos-ativos"><strong>Título:</strong> {item.title}</p>
                                                                                    {item.subtitle && <p className="infos-ativos"><strong>Subtítulo:</strong> {item.subtitle}</p>}
                                                                                    <p className="infos-ativos"><strong>Data de publicação:</strong> {moment(item.published_at).format("DD/MM/YYYY")}</p>
                                                                                    <p className="infos-ativos "><strong>Sinopse:</strong> {item.synopsis} </p>
                                                                                    <p className="infos-ativos "><strong>Link do E-commerce:</strong> {item.ecommerce_url} </p>
                                                                                    <p className="infos-ativos "><strong>Categorias:</strong> {!!item.categories && item.categories.split(",").join(" / ")}</p>
                                                                                    <p className="infos-ativos "><strong>ID:</strong> {item.id} </p>
                                                                                </>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>

                                <div className="col-12 d-flex justify-content-center pt-3">
                                    <Pagination onChange={onChangePage} current={paginacao.paginaAtual} total={paginacao.totalPaginas * paginacao.limite} pageSize={paginacao.limite} />
                                </div>
                            </>
                        }


                    </div>
                </div>
            </div>
            <ErrorModal
                isOpen={openErrorModal}
                message={errorMessage}
                closeErrorModal={() => { clearBusca(); toggleErrorModal(); }}
            />
        </>
    )
}


export default withRouter(CileContentBooks);